<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_payment')">
                <template slot="title">
                    <i class="fa fa-dollar mr-2"></i>{{Core.Definition.getDefinition('Paiements')}}
                </template>
                <ReportCommercePayment class="mt-4"></ReportCommercePayment>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_order')">
                <template slot="title">
                    <i class="fa fa-shopping-cart mr-2"></i>{{Core.Definition.getDefinition('Commandes')}}
                </template>
                <ReportCommerceOrder class="mt-4"></ReportCommerceOrder>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_recurring_subscription')">
                <template slot="title">
                    <i class="fa fa-refresh mr-2"></i>{{Core.Definition.getDefinition('Abonnements récurrents')}}
                </template>
                <ReportCommerceRecurringSubscription class="mt-4"></ReportCommerceRecurringSubscription>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_limited_subscription')">
                <template slot="title">
                    <i class="fa fa-sort-numeric-desc mr-2"></i>{{Core.Definition.getDefinition('Abonnements limités')}}
                </template>
                <ReportCommerceLimitedSubscription class="mt-4"></ReportCommerceLimitedSubscription>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_ticket')">
                <template slot="title">
                    <i class="fa fa-ticket mr-2"></i>{{Core.Definition.getDefinition('Participants')}}
                </template>
                <ReportCommerceTicket class="mt-4"></ReportCommerceTicket>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_ticket')">
                <template slot="title">
                    <i class="fa fa-dollar mr-2"></i>{{Core.Definition.getDefinition('Sommaires')}}
                </template>
                <ReportCommerceSummary class="mt-4"></ReportCommerceSummary>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_ticket')">
                <template slot="title">
                    <i class="fa fa-dollar mr-2"></i>{{Core.Definition.getDefinition('Codes promo')}}
                </template>
                <ReportCommercePromoCode class="mt-4"></ReportCommercePromoCode>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_commerce_stock')">
                <template slot="title">
                    <i class="fa fa-archive mr-2"></i>{{Core.Definition.getDefinition('Inventaire')}}
                </template>
                <ReportCommerceStock class="mt-4"></ReportCommerceStock>
            </b-tab>
            <b-tab v-if="Core.Session.environmentId === '24'">
                <template slot="title">
                    <i class="fa fa-archive mr-2"></i>{{Core.Definition.getDefinition('Ventes 2019-2020')}}
                </template>
                <ReportCommerceSales20192020 class="mt-4"></ReportCommerceSales20192020>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import ReportCommercePayment from './Payment'
    import ReportCommerceLimitedSubscription from './LimitedSubscription'
    import ReportCommerceRecurringSubscription from './RecurringSubscription'
    import ReportCommerceStock from './Stock'
    import ReportCommerceOrder from './Order'
    import ReportCommerceTicket from './Ticket'
    import ReportCommercePromoCode from './PromoCode'
    import ReportCommerceSummary from './Summary'
    import ReportCommerceSales20192020 from './Sales20192020'
    export default {
        name: 'ReportCommercePanel',
        components: {
            ReportCommercePayment,
            ReportCommerceLimitedSubscription,
            ReportCommerceRecurringSubscription,
            ReportCommerceStock,
            ReportCommerceTicket,
            ReportCommerceOrder,
            ReportCommerceSales20192020,
            ReportCommerceSummary,
            ReportCommercePromoCode
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
